import {
  init
} from '../../src/application/actions/user.js';

import {
  clientlist,
  clientdetail,
  clientcontacts
} from '../../src/application/actions/agents.js';

import {
  invoiceList,
  paymentList,
  invoiceDownload,
  invoicePreview,
  invoicePreviewView
} from '../../src/application/actions/invoices.js';
import {
  ddtList
} from '../../src/application/actions/ddt.js';

import {
  orders,
  orderdetail,
  fileList,
  fileListModalOpen,
  orderVestizione,
  portafoglioordini,
  sostituzioni,
  orderConfirm,
  orderCancel,
  orderDownloadAll,
  orderDownloadConferma,
  ordersets,
  view3dModel,
  open3dView,
  relations,
  totalizzazioniInit,
  initEventiOrdine,
  orderNotificaRead,
  orderNotificaDelete
} from '../../src/application/actions/orders.js';

import {
  portafoglioreclami,
  nuovoReclamoSend,
  nuovoReclamoAddPictures,
  nuovoReclamoRemovePictures,
  nuovoReclamoUpdate,
  nuovoReclamoInit
} from '../../src/application/actions/reclami.js';

import {
  twebredirect
} from '../../src/application/actions/tweb.js';

import {
  mailModalOpen,
  orderEmailSend,
  clientEmailSend,
  invoiceEmailSend,
  sendCorrespondentMail
} from '../../src/application/actions/email.js';

import {
  getInfoUtente
} from '../../src/application/actions/profile.js';

const actions = {
  init,
  clientlist,
  clientdetail,
  clientcontacts,
  orders,
  orderdetail,
  sostituzioni,
  portafoglioordini,
  orderVestizione,
  orderConfirm,
  orderCancel,
  orderDownloadAll,
  orderDownloadConferma,
  ordersets,
  view3dModel,
  open3dView,
  relations,
  mailModalOpen,
  orderEmailSend,
  clientEmailSend,
  invoiceEmailSend,
  sendCorrespondentMail,
  invoiceDownload,
  invoicePreview,
  invoicePreviewView,
  fileList,
  fileListModalOpen,
  invoiceList,
  paymentList,
  ddtList,
  portafoglioreclami,
  twebredirect,
  getInfoUtente,
  totalizzazioniInit,
  initEventiOrdine,
  orderNotificaRead,
  orderNotificaDelete
}


export default actions;